import { render, staticRenderFns } from "./RewardCategory.vue?vue&type=template&id=40c7c3aa&scoped=true"
import script from "./RewardCategory.vue?vue&type=script&lang=ts"
export * from "./RewardCategory.vue?vue&type=script&lang=ts"
import style0 from "./RewardCategory.vue?vue&type=style&index=0&id=40c7c3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7c3aa",
  null
  
)

export default component.exports